export default "__VITE_ASSET__2b847c39__"